"use client";

import { Tabs, TabsList, TabsTrigger } from "@/core/components/ui/tabs";
import type { MyProductsViewToggleProps, ViewMode } from "../types";
import { useTranslation } from "react-i18next";

export function MyProductsViewToggle({
  mode,
  onChange,
  className,
}: MyProductsViewToggleProps) {
  const [translate] = useTranslation(["dashboard"]);

  return (
    <Tabs
      value={mode}
      onValueChange={(v) => onChange(v as ViewMode)}
      className={className}
    >
      <TabsList className="w-full">
        <TabsTrigger value="currency">
          {translate("dashboard-my-products-view-toggle-currency")}
        </TabsTrigger>
        <TabsTrigger value="credits">
          {translate("dashboard-my-products-view-toggle-credits")}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
